@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.support

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.support.SupportIssueDto

object UpsertSupportIssueEndpoint : EndPoint<UpsertSupportIssueEndpoint.Request, UpsertSupportIssueEndpoint.Response>() {
    class Request(
        val supportIssue: SupportIssueDto
    )

    class Response()
}